import { AssembleTruncatedTypography } from "../AssembleTruncatedTypography";

export function TruncatedNameCell({ value }: { value: string | null }) {
  return (
    <AssembleTruncatedTypography lines={2}>
      {value ?? "-"}
    </AssembleTruncatedTypography>
  );
}
